import React from 'react';
export function CompanyCardHeader() {
  return ' ';
}